<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import youtubeThumbnail from './images/ASM1ybLuDbg.jpg?w=610';
	import officeInterior from './images/CS-office-soundproofing-04-e1548718880231.jpg';
	import bayWindows from './images/case-study-conference-room-comfort-003.jpg';
	import {
		default as hotelInterior,
		default as installationImage,
	} from './images/case-study-soundproofing-hotel-windows-004-e1548719056505.jpg';
</script>

<Section>
	<p>
		These are Indow windows reviews and quotes from general managers, CEOs,
		business owners, and architects who bought interior commercial storm windows
		for their property. They might have been looking to <a
			href="/commercial-storm-windows/office-soundproofing"
			>soundproof windows for office spaces</a
		> or reduce hotel noise, but they all wanted to preserve their original windows.
	</p>
	<Image src={officeInterior} />
	<p>
		Many old buildings contain landmark windows, which must be preserved for
		historic and architectural significance, and often due to regulations. Indow
		inserts are the perfect solution. Even if the windows are out of square,
		because of our 6 point laser measurement system, our inserts fit perfectly
		and nearly invisibly.
	</p>
</Section>
<Section>
	<h2>Luxury Hotel, Less Than Luxury Noise</h2>
	<p>
		This hotel went through a lot of trouble to ensure they gave their guests a
		luxury experience. Unfortunately, noise interrupted the relaxation guests
		sought in this beautiful Victorian. Indow commercial storm windows helped
		reduce hotel noise so guests could enjoy themselves:
	</p>
	<Bubble class="mx-auto my-16!">
		<span
			class="
     -mb-2 -ml-6 w-full text-left text-3xl font-normal text-indow-grey
     not-italic
   ">❝</span
		>
		<blockquote class="mb-0 text-xl font-bold italic">
			It was such a drastic difference. It was night and day. We’re 100%
			confident it will handle all the noise complaints generated from the
			street.
		</blockquote>
		<span
			class="
     -mt-2 -mr-6 w-full text-right text-3xl font-normal text-indow-grey
     not-italic
   ">❞</span
		>

		<p class="mb-0 w-full text-right font-extrabold text-indow-blue!">
			<span class="text-indow-grey-dark">–</span> 21 Broad Street General Manager,
			Dan Matter
		</p>
	</Bubble>
	<p>
		The inserts at 21 Broad Street blend in so well, Dan had completely
		forgotten they were there when he went to do some maintenance work on a
		window. But most of the time he remembers because the hotel noise reduction
		is so drastic. “You can hear the difference,” he said. “You can feel the
		difference.”
	</p>
	<Image src={hotelInterior} />
</Section>
<Section>
	<h2>Cold to Cozy Conference Room</h2>
	<p>
		Conference calls were plagued by echoes and fire truck sirens. Meetings were
		guest to shivers and rattling panes. Because of the historic preservation
		commission, replacement windows would be $100,000 or more.
	</p>
	<p>
		Then they found Indow to bring commercial storm windows and warmth to their
		office space:
	</p>
	<Bubble class="mx-auto my-16!">
		<span
			class="
     -mb-2 -ml-6 w-full text-left text-3xl font-normal text-indow-grey
     not-italic
   ">❝</span
		>
		<blockquote class="mb-0 text-xl font-bold italic">
			The difference in the comfort of those rooms is striking. It was
			embarrassing, now people gravitate to those rooms because they’re so quiet
			compared to the other rooms.
		</blockquote>
		<span
			class="
     -mt-2 -mr-6 w-full text-right text-3xl font-normal text-indow-grey
     not-italic
   ">❞</span
		>

		<p class="mb-0 w-full text-right font-extrabold text-indow-blue!">
			<span class="text-indow-grey-dark">–</span> David Weigelt
		</p>
	</Bubble>

	<p>
		The Market Street building, now over 100 years old, finds its conference
		room a gathering place for more than meetings. David has to kick employees
		out when he needs it for training or a client.
	</p>

	<Image src={bayWindows} />
</Section>
<Section>
	<h2>Historic College Windows Saved From Drafts & Damage</h2>
	<p>
		Bowdoin College had single-pane windows that are beautiful, but let in
		drafts, cold, and noise. Noise like the chapel bells that ring every 15
		minutes. Exterior storm windows and plastic film didn’t fit the gorgeous
		romanesque features, but Indow interior commercial storm windows fit
		perfectly.
	</p>
	<Bubble class="mx-auto my-16!">
		<span
			class="
     -mb-2 -ml-6 w-full text-left text-3xl font-normal text-indow-grey
     not-italic
   ">❝</span
		>
		<blockquote class="mb-0 text-xl font-bold italic">
			They’re nearly invisible. Unless you know they’re there, you don’t know
			they’re there.
		</blockquote>
		<span
			class="
     -mt-2 -mr-6 w-full text-right text-3xl font-normal text-indow-grey
     not-italic
   ">❞</span
		>

		<p class="mb-0 w-full text-right font-extrabold text-indow-blue!">
			<span class="text-indow-grey-dark">–</span> Shawn Gerwig, Administrative Coordinator,
			McKeen Center
		</p>
	</Bubble>
	<p>Caitlin noticed the difference in the bell noise immediately:</p>
	<Bubble class="mx-auto my-16!">
		<span
			class="
     -mb-2 -ml-6 w-full text-left text-3xl font-normal text-indow-grey
     not-italic
   ">❝</span
		>
		<blockquote class="mb-0 text-xl font-bold italic">
			If it’s blocking that much sound, it’s helping with the cold. They
			eliminated the drafts.
		</blockquote>
		<span
			class="
     -mt-2 -mr-6 w-full text-right text-3xl font-normal text-indow-grey
     not-italic
   ">❞</span
		>

		<p class="mb-0 w-full text-right font-extrabold text-indow-blue!">
			<span class="text-indow-grey-dark">–</span> Caitlin Callahan, Assistant Director,
			Mckeen Center
		</p>
	</Bubble>
	<Image src={installationImage} />
</Section>

<Section>
	<h2>Architect Uses Commercial Storm Windows for Home Restoration</h2>
	<p>
		John Eifler is an architect who lives in a Frank Lloyd Wright home in
		Glencoe, Illinois. He’s spent years restoring his home to Frank Lloyd
		Wright’s original architectural and engineering specifications. No detail is
		overlooked, and each room needs its own solution.
	</p>
	<p>
		Eifler has found that Indow commercial storm windows work for many of the
		challenges this home has presented—all of them including the need to
		preserve the historic windows and increase their performance level. Watch
		the video for the full account:
	</p>
	<Youtube
		src="https://www.youtube.com/watch?v=ASM1ybLuDbg"
		posterImageSrc={youtubeThumbnail}
		title="Architects Seminar"
	/>
	<p>
		Read more testimonials from those who have worked with us on <a
			href="/resources/case-studies">commercial projects</a
		>.
	</p>
</Section>
<GetAFreeEstimate />
